import type {UploadFile} from 'antd';
import type {RcFile} from 'antd/es/upload';

import {ImportCustomReviewsPayloadType} from '../../../../../service/reviews/reviews-custom-reviews-import-helper';

import {
    ImportReviewsEntityScopeEnum,
    ImportReviewsFormFieldNamesEnum,
    ImportReviewsFormFieldsType,
} from './import-reviews-form-type';

export function normalizeImportReviewsUploadFileList(
    event: {fileList: Array<UploadFile<RcFile>>} | Array<UploadFile<RcFile>>
): Array<UploadFile<RcFile>> {
    if (Array.isArray(event)) {
        return event;
    }

    return event?.fileList ?? [];
}

function getReviewsFileFromFormField(fileList?: Array<UploadFile<RcFile>>): File {
    const uploadFile = fileList?.[0];
    const file = uploadFile?.originFileObj ?? uploadFile;

    if (!(file instanceof File)) {
        throw new TypeError('Reviews file is required');
    }

    return file;
}

export function serializeImportReviewsForm(fields: ImportReviewsFormFieldsType): ImportCustomReviewsPayloadType {
    const brandId = fields[ImportReviewsFormFieldNamesEnum.brand];

    if (!brandId) {
        throw new Error('brand_id is required');
    }

    const tagIds = (fields[ImportReviewsFormFieldNamesEnum.tags] ?? []).map((tag) => tag.id);
    const isCompanyScope = fields[ImportReviewsFormFieldNamesEnum.entityScope] === ImportReviewsEntityScopeEnum.company;

    return {
        reviewsFile: getReviewsFileFromFormField(fields[ImportReviewsFormFieldNamesEnum.reviewsFile]),
        brandId,
        ...(isCompanyScope ? {companyId: fields[ImportReviewsFormFieldNamesEnum.company]} : {}),
        ...(tagIds.length > 0 ? {tagIds} : {}),
    };
}
